import documentsList from "../../data/documents.json";
import http from "@/utils/service/http";
import $log from "@/utils/service/log";

export const TERMS_OF_SERVICE = "website_tos";
export const PRIVACY_POLICY = "privacy_policy";
export const COOKIE_POLICY = "cookie_policy";
export const REFUND_POLICY = "refund_policy";
export const DESKTOP_EULA = "desktop_eula";
export const MOBILE_EULA = "mobile_eula";
export const COOKIE_CONSENT = "cookie_consent_banner";
export const ACCESSIBILITY_SCAN = "accessibility_scan";

export const documents = (locale = null) => {
    if (!locale) return documentsList;

    const filtered = documentsList.filter(({ locales }) =>
        locales.includes(locale),
    );

    if (filtered.length <= 0) {
        $log.notify(new Error("Locale does not have any files"), (event) => {
            event.addMetadata("locale", locale);
            event.addMetadata("filtered", filtered);
        });
        return documentsList || [];
    }

    return filtered || [];
};

export let documentImage = (document) => {
    try {
        return require(`~@/assets/v1/images/Documents/${document.img}`);
    } catch {
        return require(`~@/assets/v1/images/Documents/general.svg`);
    }
};

export let documentImageByType = (type) => {
    let documentImg = documents().find(({ slug }) => slug === type);

    try {
        return require(`~@/assets/v3/images/products/${documentImg?.img}`);
    } catch {
        return require(`~@/assets/v3/images/products/general-policy.svg`);
    }
};

export let documentNameByType = (type) => {
    return documents().find(({ slug }) => slug === type)?.name ?? "Document";
};

export const documentFeatureByType = (type) => {
    return documents().find(({ slug }) => slug === type)?.feature ?? "";
};

export let addToWebsite = (doc) => {};

export let documentRender = async (uuid, format = "html", project = false) => {
    const url = project
        ? `/api/v1/project-documents/${uuid}/rendered`
        : `/api/v1/documents/${uuid}/rendered`;

    return await http.get(url, {
        params: {
            format,
        },
    });
};

export let documentRenderDemo = async (params) => {
    try {
        return await http.post(`/api/v1/documents/render-demo`, params);
    } catch (e) {
        return null;
    }
};

export let documentGenerate = async (uuid, domain = null, format = "html") => {
    try {
        return await http.post(`/api/v1/documents/${uuid}/generate`, {
            format,
            domain,
        });
    } catch (e) {
        return null;
    }
};

export const documentNewestVersion = (document, versions = []) => {
    const docVersion = parseFloat(document.version?.replace(/^v/, ""));
    return (
        "v" +
            Object.entries(versions).reduce(
                (currentVersion, [version, missingFields]) => {
                    const v = parseFloat(version?.replace(/^v/, ""));
                    return v > currentVersion ? v : currentVersion;
                },
                docVersion,
            ) || docVersion
    );
};

export const documentFileByType = (type, content, title = null) => {
    let mimeType = "";
    switch (type) {
        case "html":
            mimeType = "text/html";
            content = encodeURIComponent(content);
            break;
        case "pdf":
            mimeType = "application/pdf;base64";
            break;
        case "text":
        case "txt":
        case "md":
            mimeType = "text/plain;charset=UTF-8;base64";
            content = btoa(unescape(encodeURIComponent(content)));
            break;
    }

    downloadFile(content, title || `document.${type}`, mimeType);
};

export const downloadFile = (
    content,
    title = "document.pdf",
    type = "application/pdf",
) => {
    const linkSource = `data:${type},${content}`;
    const downloadLink = document.createElement("a");
    const fileName = title;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
};
